<div class="mb-5">
	<app-daily-utilization-chart
		*ngIf="data"
		[chart]="chart"
		[showUsageValue]="true"
		[maxValue]="800"
		[chartType]="chartType"
		[hasTruckTypeFilter]="false"
		[hasCapacityFilter]="true"
		[hasVoltageFilter]="true"
		[devicesType]="devicesType"
		[title]="'utilization.daily_ah_battery_fleet_utilization' | translate"
		[tooltipText]="'battlinkDevice.daily_ah_fleet_utilization'"
		[fromDate]="fromDate"
		[toDate]="toDate"
		[selectedBatteryVoltage]="selectedBatteryVoltage"
		[selectedBatteryCapacity]="selectedBatteryCapacity"
		[selectedBatteryVintage]="selectedBatteryVintage"
		[selectedTruckManufacturer]="selectedManufacturer"
		[userParentFilters]="true"
		[vAxisTitle]="'site.number_of_batteries' | translate"
		(prepareParentFiltersOptions)="prepareParentFiltersOptionsEmitter($event)"
	></app-daily-utilization-chart>
</div>
